import { TERMINALS_ACTION_TYPES } from "../actions/terminals.action";

const initialState = {
   terminalsInfo: [],
   terminalInfo: {},
   isLoading: false,
   terminals: [],
   preference: [],
   locationProducts: []
};

const terminalsReducer = (state = initialState, action) => {
   switch (action.type) {
      case TERMINALS_ACTION_TYPES.GET_TERMINALS_INFO_DATA:
         return {
            ...state,
            isLoading: true,
         };
      case TERMINALS_ACTION_TYPES.GET_TERMINALS_DATA_INFO_DATA_DONE:
         return {
            ...state,
            terminalsInfo: action.payload,
            isLoading: false,
         };

      case TERMINALS_ACTION_TYPES.GET_TERMINAL_DATA_BY_ID:
         return {
            ...state,
            isLoading: true,
         };
      case TERMINALS_ACTION_TYPES.GET_TERMINAL_DATA_BY_ID_DONE:
         return {
            ...state,
            terminalInfo: action.payload,

            isLoading: false,
         };

      case TERMINALS_ACTION_TYPES.DELETE_TERMINAL_DATA:
         return {
            ...state,
            isLoading: true,
         };
      case TERMINALS_ACTION_TYPES.DELETE_TERMINAL_DATA_DONE:
         return {
            ...state,
            isLoading: false,
         };

      case TERMINALS_ACTION_TYPES.POST_TERMINAL_DATA:
         return {
            ...state,
            isLoading: true,
         };
      case TERMINALS_ACTION_TYPES.POST_TERMINAL_DATA_DONE:
         return {
            ...state,
            isLoading: false,
         };

      case TERMINALS_ACTION_TYPES.GET_TERMINALS_PREFERENCES_LOCATION_PRODUCT_DATA:
         return {
            ...state,
            isLoading: true,
         };
      case TERMINALS_ACTION_TYPES.GET_TERMINALS_PREFERENCES_LOCATION_PRODUCT_DATA_DONE:
         return {
            ...state,
            terminals: action.payload.Terminals.length > 0 ? action.payload.Terminals : [],
            preference: action.payload.Preference.length > 0 ? action.payload.Preference : [],
            locationProducts: action.payload.LocationProducts.length > 0
               ? action.payload.LocationProducts
               : [],
            isLoading: false,
         };

      case TERMINALS_ACTION_TYPES.PUT_TERMINALS_INFO_DATA:
         return {
            ...state,
            isLoading: true,
         };
      case TERMINALS_ACTION_TYPES.PUT_TERMINALS_INFO_DATA_DONE:
         return {
            ...state,
            isLoading: false,
         };

      default:
         return state;
   }
}

export default terminalsReducer;

/**
 * 4
 * Fedral and state
 * 2 fed
 * 2 state
 * 
 * 2 sercharges
 * total charges
 * Taxes and Surchages: ${amount} Show Details
 */